export const css = {
	dark: 'bKhTkH0W',
	' _key': 'afcpe-theme/afcpe/micro/mc-widgets/card-button'
};

export default css;
